"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeySettingsEdition = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const prop_types_1 = __importDefault(require("prop-types"));
const SankeyLayout_1 = require("./SankeyLayout");
const types_1 = require("./types");
const SankeySettingsEditionPropTypes = {
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired
};
const SankeySettingsEdition = ({ data, set_data, children }) => {
    const [user_scale, set_user_scale] = (0, react_1.useState)(data.user_scale);
    const [node_hspace, set_node_hspace] = (0, react_1.useState)(data.h_space);
    const [node_vspace, set_node_vspace] = (0, react_1.useState)(data.v_space);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Echelle")),
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: user_scale, onChange: evt => set_user_scale(+evt.target.value), onBlur: () => {
                            data.user_scale = user_scale;
                            set_data(Object.assign({}, data));
                        } }),
                    react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, null),
                    react_1.default.createElement(react_bootstrap_1.Form.Text, null, "    (valeur pour 100px)"))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Taille Carr\u00E9 Grille")),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "number", min: 1, max: 100, step: 1, value: data.grid_square_size, onChange: evt => {
                            data.grid_square_size = (+evt.target.value >= 1) ? +evt.target.value : 10;
                            set_data(Object.assign({}, data));
                        } })),
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: data.grid_visible, label: 'Grille visible', onChange: () => {
                            data.grid_visible = !data.grid_visible;
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                            (0, SankeyLayout_1.arrangeNodes)(data);
                            set_data(Object.assign({}, data));
                        } }, "Arranger noeuds"))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Ecart entre noeuds")),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Horizontal")),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: node_hspace, onChange: evt => {
                            set_node_hspace(+evt.target.value);
                            data.h_space = +evt.target.value;
                        } })),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Vertical")),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: node_vspace, onChange: evt => {
                            set_node_vspace(+evt.target.value);
                            data.v_space = +evt.target.value;
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                            (0, SankeyLayout_1.compute_auto_sankey)(data, node_hspace);
                            set_data(Object.assign({}, data));
                        } }, " Positionnement automatique")))),
        react_1.default.createElement(react_bootstrap_1.Tabs, { id: "settings-layout" }, children)));
};
exports.SankeySettingsEdition = SankeySettingsEdition;
SankeySettingsEdition.propTypes = SankeySettingsEditionPropTypes;
exports.default = null;
